import { useSavings } from "../../hooks/useSavings";
import Card from "../../components/ui/Card";
import StatCard from "../../components/ui/StatCard";
import Badge from "../../components/ui/Badge";
import Input from "../../components/ui/Input";
import { useState } from "react";
import Button from "../../components/ui/Button";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/client";

const fmt = (n: number) =>
new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN", currencyDisplay: "symbol", maximumFractionDigits: 0 }).format(n);
const fmtDate = (d: string) =>
  d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

const typeIcon  = (t: string) => t === "savings" ? "💰" : t === "withdrawal" ? "📤" : "🔄";
const typeColor = (t: string) => t === "savings" ? "text-emerald-600" : t === "withdrawal" ? "text-red-500" : "text-blue-600";

export default function MemberTargetSavingsPage() {
  const navigate = useNavigate();
  const { id }   = useParams<{ id: string }>();
  const { data } = useSavings() as any;
  const [purpose, setPurpose] = useState("");

  const [form, setForm] = useState({purpose:"",targetAmount:"",targetStatus:"active",startDate:"",stopDate:""});

  const set = (k: string) => (v: string) => setForm(f => ({ ...f, [k]:v }));

  const handleSubmit = async () => {
    if (purpose === "" || Number(form.targetAmount) < 10000 || form.startDate === "" || form.stopDate === ""){
      alert('Invalid entry in one/more field(s)! Please correct and continue. Note, target amount must be greater than 10,000.');
      return;
    }
    const response = await api.post("/savings/targetdetails", {id:id,purpose:purpose, targetAmount:form.targetAmount,targetStatus:form.targetStatus,startDate:form.startDate,stopDate:form.stopDate}) as any;
    if (response.status === "Failed"){alert('Error saving target! '+response.error);}
    else{
      alert('Target saved. '+response.error);
      setForm({purpose:"",targetAmount:"",targetStatus:"active",startDate:"",stopDate:""});
      setPurpose("");
      navigate("/savings");
    }
  };

  return (
    <div>
      <Button variant="outline" size="sm" onClick={() => navigate("/savings")} className="mb-5">← Back</Button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <Card>
          <p className="text-sm font-medium text-slate-700 mb-4">Target Saving Details</p>
          <label className="block text-sm font-medium text-slate-700 mb-1.5">Purpose of savings</label>
          <input value={purpose} onChange={(e) =>setPurpose(e.target.value)} className={`w-full px-3 py-2.5 border rounded-lg text-sm text-slate-800 outline-none bg-white`} maxLength={255} placeholder="Type purpose of savings" />
          <Input type="number" label="Target Amount" value={form.targetAmount} onChange={set("targetAmount")} placeholder="Enter target amount" />
          <Input type="date" label="Target Start Date" value={form.startDate} onChange={set("startDate")} placeholder="05/20/2026" />
          <Input type="date" label="Target End Date" value={form.stopDate} onChange={set("stopDate")} placeholder="12/30/2026" />
                    
          <Button variant="primary" onClick={handleSubmit}>Save Target Details</Button>
        </Card>
      </div>
    </div>
  );
}
